@charset "UTF-8";

/* src/app/pages/notification-preferences/notification-preferences.page.scss */
ion-header {
  padding-top: env(safe-area-inset-top);
}
/*# sourceMappingURL=notification-preferences.page.css.map */
